/* eslint-disable react/jsx-handler-names */
import 'componentsV2/OTPTransfer/OTPTransfer.scss';

// @vendors
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// @ commons
import { FormattedText } from 'core/i18n';

// @ utilities
import { toCamelCase } from 'utilities/stringHelper';
import { recordEvent } from 'utilities/uTagging';

// @ components
import OtpTransferCodeBox from 'componentsV2/OTPTransferCodeBox/OTPTransferCodeBox';
import OtpTransferSteps from 'componentsV2/OTPTransfer/OTPTransferSteps/OTPTransferSteps';
import OtpTransferStepsTitle from './OTPTransferStepsTitle';
import Headline from 'components/headline';

// @actions
import { ibanTransferOTPCall } from 'actions/ibanActions';
import { hidePreLoader, showPreLoader } from 'actions/preLoaderActions';

import { CREDIT_CARD } from 'constants/userProfile';

const OtpTransferComponent = ({
    otpDate,
    iban,
    entityName,
    userProfile,
    onHandleDisableNextButton,
    retryTransfer,
    onHandleSetOtpTransferData,
    showHelpModal,
    showAlternativeOption,
    hideAlternativeOptionModal,
    investmentType,
}) => {
    const injectedDates = [otpDate.substring(0, 11), otpDate.substring(11)];
    const otpSteps = [
        {
            id: '01',
            text: <FormattedText value="otpCode-transferOTPFirstStep" />,
        },
        {
            id: '02',
            text: <FormattedText value="otpCode-transferOTPSecondStep" injectedStrings={injectedDates} />,
        },
        {
            id: '03',
            text: <FormattedText value="otpCode-transferOTPThirdStepModal" />,
        },
    ];
    const otpNerudaSteps = [
        {
            id: '01',
            text: <FormattedText value="otpCode-transferOTPFirstStep" />,
        },
        {
            id: '02',
            text: <FormattedText value="otpCode-transferOTPSecondStep" injectedStrings={injectedDates} />,
        },
        {
            id: '03',
            text: <FormattedText value="otpCode-transferOTPThirdStep_TC" />,
        },
    ];

    const onClickHelpLink = event => {
        showHelpModal(event);

        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            accionEvento: 'otp-ibanid',
            etiquetaEvento: 'te ayudamos',
            categoriaEvento: 'eventos IBAN OTP',
        });
    };

    const getStepsByInvestementType = () => (investmentType === CREDIT_CARD ? otpNerudaSteps : otpSteps);

    const isCreditCardInvestementType = () => investmentType === CREDIT_CARD;

    return (
        <Fragment>
            <section className={'otp-transfer-container'}>
                <div>
                    <Headline icon="identificacion" className="prospects-gutter prospects-initial">
                        <h2>
                            <FormattedText value="StepsTitles-transferOtpValidation" />
                        </h2>
                        <h5>
                            <FormattedText
                                value="StepsTitles-transferOtpValidationDescription"
                                injectedStrings={[toCamelCase(userProfile.name), iban, entityName]}
                            />
                        </h5>
                    </Headline>
                </div>
                <div className="opt-transfer-container-content">
                    <OtpTransferStepsTitle name={userProfile.name} />
                    <OtpTransferSteps otpSteps={getStepsByInvestementType()} />

                    {!isCreditCardInvestementType() && (
                        <p className="opt-transfer-modal-link" onClick={onClickHelpLink}>
                            <FormattedText value="otpCode-transferOTPThirdStepModalLink" />
                        </p>
                    )}
                    <OtpTransferCodeBox
                        onHandleSetOtpTransferData={onHandleSetOtpTransferData}
                        retryTransfer={retryTransfer}
                        onHandleDisableNextButton={onHandleDisableNextButton}
                        showAlternativeOption={showAlternativeOption}
                        handleOnFocusInput={hideAlternativeOptionModal}
                        showHelpModal={showHelpModal}
                        displayCodeNotFound={isCreditCardInvestementType()}
                        hideAlternativeOptionModal={hideAlternativeOptionModal}
                    />
                </div>
            </section>
        </Fragment>
    );
};

OtpTransferComponent.defaultProps = {
    otpDate: 'XX/XX/XX',
    retryTransfer: false,
    iban: '',
    onHandleDisableNextButton: () => {},
    onHandleSetOtpTransferData: () => {},
};

OtpTransferComponent.propTypes = {
    otpDate: PropTypes.string.isRequired,
    iban: PropTypes.string.isRequired,
    retryTransfer: PropTypes.bool.isRequired,
    onHandleDisableNextButton: PropTypes.func.isRequired,
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
    }),
    { ibanTransferOTPCall, showPreLoader, hidePreLoader }
)(OtpTransferComponent);
